import type { CtaBandData } from '@/content/types';

export default function CtaBand(props: CtaBandData) {
  return (
    <section className="section-padding" style={{ textAlign: 'center' }}>
      <h2 className="h-feature">{props.title}</h2>
      {props.body && <p style={{ marginTop: 16, color: 'var(--color-muted)' }}>{props.body}</p>}
      <a href={props.cta.href} className="btn-primary" style={{ marginTop: 24 }}>
        {props.cta.label}
      </a>
    </section>
  );
}
